/**
 * @packageDocumentation
 * @module      UserLoggedOutEvent.ts
 * @description A custom event that is fired when a user logs out.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * A custom event that is fired when a user logs out.
 */
export class UserLoggedOutEvent extends CustomEvent {
    /** Constructor. */
    constructor() {
        super(UserLoggedOutEvent.eventName, {
            bubbles: true,
            composed: true
        });
    }
}
/** The name of the event. */
UserLoggedOutEvent.eventName = "userLoggedOut";
//# sourceMappingURL=UserLoggedOutEvent.js.map